import { Dispatch } from "react"
import ReactModal from "react-modal"

type AutogenResultsModalProps = {
  appContainer: HTMLDivElement | null
  isOpen: boolean
  setOpen: Dispatch<boolean>
  autogenerateResult: any
}

export const AutogenResultsModal = (props: AutogenResultsModalProps) => {
  const { appContainer, isOpen, setOpen, autogenerateResult } = props

  return (
    <ReactModal
      appElement={appContainer || undefined}
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          padding: 10,
          zIndex: 10,
          borderRadius: 5,
          bottom: "auto",
        },
        overlay: {
          zIndex: 10,
          background: "rgba(0,0,0,0.1)",
        },
      }}
    >
      <div>
        <div style={{ marginBottom: 20 }}>Generated:</div>
        {autogenerateResult?.sheetsData?.length ? (
          <div style={{ marginBottom: 10 }}>
            {autogenerateResult?.sheetsData?.length}{" "}
            {autogenerateResult?.sheetsData?.length === 1 ? "Sheet" : "Sheets"}
          </div>
        ) : null}
        {autogenerateResult?.cellsData?.length ? (
          <div style={{ marginBottom: 10 }}>
            {autogenerateResult?.cellsData?.length}{" "}
            {autogenerateResult?.cellsData?.length === 1 ? "Cell" : "Cells"}
          </div>
        ) : null}
        {autogenerateResult?.logicsData?.length ? (
          <div style={{ marginBottom: 10 }}>
            {autogenerateResult?.logicsData?.length}{" "}
            {autogenerateResult?.logicsData?.length === 1 ? "Logic" : "Logics"}
          </div>
        ) : null}
        {autogenerateResult?.edgesData?.length ? (
          <div style={{ marginBottom: 20 }}>
            {autogenerateResult?.edgesData?.length}{" "}
            {autogenerateResult?.edgesData?.length === 1
              ? "Connection"
              : "Connections"}
          </div>
        ) : null}
      </div>
      <button
        className="api-button"
        onClick={() => setOpen(false)}
        style={{ marginTop: 5 }}
      >
        Close
      </button>
    </ReactModal>
  )
}
